import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { Box, Stack, Typography } from '@mui/material';
import {
    EditButton,
    EmailField,
    ReferenceField,
    TextField,
    useRecordContext,
} from 'react-admin';

import { Quote } from '@/types';
import { showAsideSx } from '@/components/layout/showPageLayout';


export const ContractorAside = () => {
    const record = useRecordContext<Quote>();
    if (!record) return null;

    return (
        <Box sx={showAsideSx}>
            <ReferenceField source="contractor_id" reference="contractor_owners" link={false}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Contractor <EditButton label="" title="Edit Contractor" />
                </Typography>
                <TextField source="name" />{' '}
                <TextField source="company_name" />
                <Stack
                    direction="row"
                    alignItems="center"
                    gap={1}
                    minHeight={24}
                >
                    <EmailIcon color="disabled" fontSize="small" />
                    <EmailField source="email" />
                </Stack>
                <Stack direction="row" alignItems="center" gap={1}>
                    <PhoneIcon color="disabled" fontSize="small" />
                    <Box>
                        <TextField source="phone_number" />
                    </Box>
                </Stack>
            </ReferenceField>
            <Box mt={2}>
                <ReferenceField source="property_owner_id" reference="contractor_owners" link={false}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        Owner <EditButton label="" title="Edit Owner" />
                    </Typography>
                    <TextField source="name" />{' '}
                    <TextField source="company_name" />
                    <Stack
                        direction="row"
                        alignItems="center"
                        gap={1}
                        minHeight={24}
                    >
                        <EmailIcon color="disabled" fontSize="small" />
                        <EmailField source="email" />
                    </Stack>
                    <Stack direction="row" alignItems="center" gap={1}>
                        <PhoneIcon color="disabled" fontSize="small" />
                        <Box>
                            <TextField source="phone_number" />
                        </Box>
                    </Stack>
                </ReferenceField>
            </Box>
        </Box>
    );
};
